import { render } from "./CardPedido.vue?vue&type=template&id=30872459"
import script from "./CardPedido.vue?vue&type=script&lang=js"
export * from "./CardPedido.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__